/*
 * 文件EN: APIAnalyze.js,
 * 文件CN: 分析报表,
 * 创建时间: Wednesday, 17th June 2020 9:50:38 am,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import request from '@/plugins/http'

/**
 * @desc api查询统计
 * @method GET
 * @param {}
 */
export const queryCount = params => {
  return request.get('/apiManager/apiAnalyze/queryCount', params)
}

/**
 * @desc api各类Api每天成功数
 * @method GET
 * @param {date: 选择日期, type: 0-月 1-年}
 */
export const queryApiSuccState = params => {
  return request.get('/apiManager/apiAnalyze/queryApiSuccState', params)
}

/**
 * @desc 各类Api使用总览
 * @method GET
 * @param {date: 选择日期, type: 0-月 1-年}
 */
export const queryApiUse = params => {
  return request.get('/apiManager/apiAnalyze/queryApiUse', params)
}

/**
 * @desc api调用次数预览
 * @method GET
 * @param {date: 选择日期, type: 0-月 1-年}
 */
export const queryApiCall = params => {
  return request.get('/apiManager/apiAnalyze/queryApiCall', params)
}
